import { useSelector } from 'react-redux';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { GeneralPortfolioProductSubscriptionType } from '@mews-commander/data-access';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities';

export const useSecurityDashboardFlags = () => {
    const { portfolioProductSubscriptionTypes } = useCurrentEnterprise();
    const hasSsoAccess = !!portfolioProductSubscriptionTypes?.includes(
        GeneralPortfolioProductSubscriptionType.SingleSignOn
    );
    const isPortfolio = useSelector(isCurrentEnterprisePortfolio);

    return {
        isPortfolioWithSsoSubscription: hasSsoAccess && isPortfolio,
        hasSsoSubscription: hasSsoAccess,
    };
};
